"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repeatTimes = repeatTimes;
exports.default = void 0;

var _curry = require("../../internal/curry");

var _iterable = require("../../internal/iterable");

function* repeatTimes(n, item) {
  while (n--) {
    yield item;
  }
}

var _default = (0, _curry.curry)((0, _iterable.wrapWithMethodIterable)(repeatTimes), repeatTimes.length);

exports.default = _default;